import { render } from "./EnHomeView.vue?vue&type=template&id=54f0529f&scoped=true"
import script from "./EnHomeView.vue?vue&type=script&lang=js"
export * from "./EnHomeView.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/en/Home.css?vue&type=style&index=1&id=54f0529f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f0529f"]])

export default __exports__